import { Account } from 'model/IChat';

const props = {
  LOGGED_IN: 'isLoggedIn',
  GUEST: 'is_guest',
  HOST: 'is_host',
  ORGANIZER: 'is_organizer',
  AMBASSADOR: 'is_ambassador',
  ADMIN: 'is_admin',
  PUPPET: 'is_puppet',
};

export default class AccountRoles {
  private account: Account;

  constructor(account: Account) {
    this.account = account;
  }

  has(property) {
    return Boolean(this.account?.[property]);
  }

  isLoggedIn() {
    return this.has(props.LOGGED_IN);
  }

  isUnlogged() {
    return !this.isLoggedIn();
  }

  isGuest() {
    return this.has(props.GUEST);
  }

  isHost() {
    return this.has(props.HOST);
  }

  isOrganizer() {
    return this.has(props.ORGANIZER);
  }

  isAmbassador() {
    return this.has(props.AMBASSADOR);
  }

  isAdmin() {
    return this.has(props.ADMIN);
  }

  isPuppet() {
    return this.has(props.PUPPET);
  }
}
